import { render, staticRenderFns } from "./LeaguePage.vue?vue&type=template&id=63de0333&scoped=true&"
import script from "./LeaguePage.vue?vue&type=script&lang=js&"
export * from "./LeaguePage.vue?vue&type=script&lang=js&"
import style0 from "./LeaguePage.vue?vue&type=style&index=0&id=63de0333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de0333",
  null
  
)

export default component.exports